import AiProjectClient from "@/clients/duallo/AiProjectClient";

class AiProjectService {
    async getAvailableRoboflowProjects() {
        return await AiProjectClient.getAvailableRoboflowProjects();
    }

    async getRoboflowProjectDetail(workspace, project) {
        return await AiProjectClient.getRoboflowProjectDetail(workspace, project);
    }

    async getProjectWorkflows(id) {
        return await AiProjectClient.getProjectWorkflows(id);
    }

    async getProjects() {
        return await AiProjectClient.getProjects();
    }

    async getProject(id) {
        return await AiProjectClient.getProject(id);
    }

    async createProject(request) {
        return await AiProjectClient.createProject(request);
    }

    async updateProject(id, request) {
        return await AiProjectClient.updateProject(id, request);
    }

    async deleteProject(id) {
        return await AiProjectClient.deleteProject(id);
    }

    async getProjectClasses(id) {
        return await AiProjectClient.getProjectClasses(id);
    }

    async upsertProjectClass(id, request) {
        return await AiProjectClient.upsertProjectClass(id, request);
    }
}

export default new AiProjectService();
